import { ReactComponent as HomeIcon } from 'assets/svg/home.svg';
import { ReactComponent as SettingIcon } from 'assets/svg/setting.svg';
import { ReactComponent as CheckApproveIcon } from 'assets/svg/check-approve.svg';
import { ReactComponent as AuthIcon } from 'assets/svg/auth-icon.svg';
import { ReactComponent as UsersIcon } from 'assets/svg/users-icon.svg';
import ManageProject from 'views/pages/manage-project';
import CreateProject from 'views/pages/manage-project/create';
import ProjectApprove from 'views/pages/manage-project/ProjectApprove';
import ManagerSettings from 'views/pages/manage-settings';
import ManagerAuthorization from 'views/pages/manager-authorization';
import CreateAuthorization from 'views/pages/manager-authorization/components/CreateAuthorization';
import ManagerUsers from 'views/pages/manager-users';
import CreateUsers from 'views/pages/manager-users/components/CreateUser';
import { PERMISSION, ROLE } from 'constants/permission';

const router = [
  {
    title: 'Project',
    path: '/project',
    icon: <HomeIcon />,
    leftMenu: true,
    component: <ManageProject />,
    permission: [PERMISSION.SEARCH_DCS]
  },
  {
    title: 'Approve Project',
    path: '/check-project',
    icon: <CheckApproveIcon />,
    leftMenu: true,
    component: <ProjectApprove />,
    permission: [PERMISSION.SEARCH_APPROVE_DCS]
  },
  {
    path: '/project/:projectId',
    component: <CreateProject />,
    leftMenu: false,
    permission: [PERMISSION.VIEW_DETAIL_DCS]
  },
  {
    path: '/project/create',
    component: <CreateProject />,
    permission: [PERMISSION.CREATE_DCS],
    leftMenu: false,
  },
  {
    path: '/check-project/:projectId',
    component: <CreateProject />,
    leftMenu: false,
    permission: [PERMISSION.VIEW_DETAIL_DCS]
  },
  {
    title: 'Authorization',
    path: '/authorization',
    icon: <AuthIcon />,
    leftMenu: true,
    component: <ManagerAuthorization />,
    permission: [PERMISSION.SEARCH_AUTHORIZATION],
    role: [ROLE.SYSTEM_ADMIN]
  },
  {
    title: 'Authorization',
    path: '/authorization/create',
    component: <CreateAuthorization />,
    permission: [PERMISSION.CREATE_AUTHORIZATION],
    role: [ROLE.SYSTEM_ADMIN]
  },
  {
    title: 'Authorization',
    path: '/authorization/:authorizationId',
    component: <CreateAuthorization />,
    permission: [PERMISSION.VIEW_DETAIL_AUTHORIZATION],
    role: [ROLE.SYSTEM_ADMIN]
  },
  {
    title: 'Manage User',
    path: '/user',
    icon: <UsersIcon />,
    leftMenu: true,
    component: <ManagerUsers />,
    permission: [PERMISSION.SEARCH_USERS],
  },
  {
    path: '/user/create',
    component: <CreateUsers />,
    permission: [PERMISSION.CREATE_INTERNAL_USERS],
  },
  {
    path: '/user/:userId',
    component: <CreateUsers />,
    permission: [PERMISSION.VIEW_DETAIL_AUTHORIZATION],
  },
  {
    title: 'Setting',
    path: '/setting',
    icon: <SettingIcon />,
    component: <ManagerSettings />,
    leftMenu: true,
  },
];

export default router;
